import { enTranslations } from '@I18n/en';
import { frTranslations } from '@I18n/fr';
import { Translations } from '@I18n/types';

export const translationMessages: Translations = {
  en: enTranslations,
  fr: frTranslations,
};
